// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../../images/empty_content.svg");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"remove-filters-empty-state\"> <svg-icon src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"></svg-icon> <h4>No results found.</h4> <h5>Remove some of your filters, <a ng-click=\"$ctrl.startOverCallback()\" class=\"cu-text-link-primary start-over-link\"> or start over. </a> </h5> </div> ";
// Exports
module.exports = code;